import { Link, useNavigate } from 'react-router-dom';

export interface Crumb {
  label: string;
  /** Sin `to` = pagina actual (ultima miga). */
  to?: string;
}

/**
 * Boton "Volver" + migas de pan, para la parte superior izquierda de las vistas de detalle (actividad, unidad, usuario).
 * "Volver" retrocede en el historial; si la pagina se abrio directo (enlace compartido, pestana nueva) no hay historial
 * al que volver, asi que cae en la miga anterior mas cercana con enlace, en vez de sacar al usuario de la aplicacion.
 */
export function Breadcrumbs({ items }: { items: Crumb[] }) {
  const navigate = useNavigate();
  const parent = [...items].reverse().find((c) => c.to)?.to;
  // React Router (data router) numera las entradas del historial en history.state.idx; 0 = primera de la sesion.
  const hasHistory = (window.history.state?.idx ?? 0) > 0;

  return (
    <div className="crumbs">
      {(hasHistory || parent) && (
        <button
          type="button"
          className="btn btn--ghost crumbs__back"
          onClick={() => (hasHistory ? navigate(-1) : navigate(parent!))}
        >
          <span aria-hidden>←</span> Volver
        </button>
      )}
      <nav aria-label="Ruta de navegación">
        <ol>
          {items.map((c, i) => (
            <li key={`${i}-${c.label}`}>
              {c.to && i < items.length - 1 ? (
                <Link to={c.to}>{c.label}</Link>
              ) : (
                <span aria-current={i === items.length - 1 ? 'page' : undefined}>{c.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}
